import type { ExerciseBlock } from '../api/types'

/**
 * Пометка «под цель» у блока тренировки.
 *
 * Отдельное движение и подходы, добавленные к авторскому блоку, — разные вещи:
 * «под цель» у всего блока и «+3 под цель» у части. Какую показать, решил
 * сервер (`goal_whole_block`, `goal_sets`) — клиент выбирает только подпись.
 *
 * Пробел перед пометкой — текстом, а не только отступом: иначе экранный диктор
 * прочтёт заголовок слитно («Жим лёжапод цель»).
 */
export function GoalMark({ block }: { block: ExerciseBlock }) {
  if (block.goal_exercise_id == null || !block.goal_sets) return null
  return (
    <>
      {' '}
      <span className="pill accent goal-mark">
        {block.goal_whole_block ? 'под цель' : `+${block.goal_sets} под цель`}
      </span>
    </>
  )
}
